import * as React from "react";

/**
 * "Narrow window" threshold. Exported because two places need the same
 * number: this hook measures reactively, `shouldMorphNow` (`chatHandoff.ts`)
 * measures on click. Two spellings of the same number would drift apart — and
 * a morph that has started would then find no target surface.
 */
export const MOBILE_BREAKPOINT = 768;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = React.useState<boolean>(false);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
